import React from 'react';
import './Loader.css';

const Loader = ({ size = 'medium', fullScreen = false }) => {
  const sizeClasses = {
    small: 'loader-sm',
    medium: 'loader-md',
    large: 'loader-lg',
  };

  if (fullScreen) {
    return (
      <div className="loader-fullscreen">
        <div className={`loader ${sizeClasses[size]}`}></div>
      </div>
    );
  }

  return (
    <div className="loader-container">
      <div className={`loader ${sizeClasses[size]}`}></div>
    </div>
  );
};

export default Loader;